import { CensusUploadJobDto } from '../api/dto/census-upload-job.dto'

// Drafts pins at most this many unfinished uploads above its own rows
export const DRAFTS_QUEUE_PINNED_LIMIT = 3
// Fetched once per poll; Show all lists up to this many
export const DRAFTS_QUEUE_FETCH_LIMIT = 50

export interface DraftsQueueSummaryRow {
  id: 'drafts-queue-summary'
  isQueueSummary: true
  hiddenCount: number
  isExpanded: boolean
}

export type DraftsPinnedRow = CensusUploadJobDto | DraftsQueueSummaryRow

export const isQueueSummaryRow = (row: unknown): row is DraftsQueueSummaryRow =>
  typeof row === 'object' &&
  row !== null &&
  (row as DraftsQueueSummaryRow).isQueueSummary === true

const summaryRow = (
  hiddenCount: number,
  isExpanded: boolean
): DraftsQueueSummaryRow => ({
  id: 'drafts-queue-summary',
  isQueueSummary: true,
  hiddenCount,
  isExpanded,
})

// Keeps the API order (newest first); the summary row appears only past the limit
export const buildDraftsPinnedRows = ({
  jobs,
  total,
  isExpanded,
}: {
  jobs: CensusUploadJobDto[]
  total: number
  isExpanded: boolean
}): DraftsPinnedRow[] => {
  if (total <= DRAFTS_QUEUE_PINNED_LIMIT) {
    return jobs
  }
  if (isExpanded) {
    return [...jobs, summaryRow(total - jobs.length, true)]
  }
  return [
    ...jobs.slice(0, DRAFTS_QUEUE_PINNED_LIMIT),
    summaryRow(total - DRAFTS_QUEUE_PINNED_LIMIT, false),
  ]
}
